function table() {
  $('table.contenttable').each((index, table) => {
    let $table = $(table);
    $table.wrap('<div class="table-responsive"></div>');
  });
}

export default table;
